System.register(["./dyn-main.js", "./dyn-parallax-banner.js", "./dyn-index2.js"], function(exports, module) {
  "use strict";
  var isMobile, isBreakpoint, animate, scroll;
  return {
    setters: [(module2) => {
      isMobile = module2.i;
      isBreakpoint = module2.b;
    }, (module2) => {
      animate = module2.a;
    }, (module2) => {
      scroll = module2.s;
    }],
    execute: function() {
      exports({
        initExpandableCards,
        initScrollFollowVideo
      });
      const throttle = ({ interval }, func) => {
        let ready = true;
        let timer = void 0;
        const throttled = (...args) => {
          if (!ready)
            return;
          func(...args);
          ready = false;
          timer = setTimeout(() => {
            ready = true;
            timer = void 0;
          }, interval);
        };
        throttled.isThrottled = () => {
          return timer !== void 0;
        };
        return throttled;
      };
      async function initExpandableCards(params) {
        const payload = params.payload;
        if (isMobile()) return;
        window.addEventListener("resize", () => {
          if (isMobile()) return;
        });
        const items = Array.from(document.querySelectorAll(payload.selector));
        if (items.length > 0) {
          const target = document.querySelector(payload.target);
          const animation = animate(items, {
            // transform: 'translateX(0%) translateY(0%) rotate(0deg)',
            // 使用 transition style 过渡会更自然，使用 animation style 则有更多控制，优先用 transition style
            "--x": 0,
            "--y": 0,
            "--rotate": 0
          }, {
            duration: 1,
            autoplay: false,
            ease: "easeOut",
            type: "tween"
          });
          animation.pause();
          let latestProgress = 0;
          const update = (p) => {
            if (p > 0.95) {
              target.classList.add(payload.completed_class);
            } else {
              target.classList.remove(payload.completed_class);
            }
            latestProgress = p;
            animation.time = p;
          };
          scroll(update, {
            target,
            offset: ["start end", "end end"],
            axis: "y"
          });
          if (window.Shopify.designMode) {
            target.addEventListener("shopify:section:load", () => {
              animation.time = latestProgress;
            });
          }
        }
      }
      function isSameOrigin(url) {
        const a = document.createElement("a");
        a.href = url;
        return a.hostname === window.location.hostname;
      }
      async function initScrollFollowVideo(params) {
        const payload = params.payload;
        async function getVideoBlob(url) {
          const resp = await fetch(url);
          const blob = await resp.blob();
          return new Blob([blob], {
            type: "video/mp4"
          });
        }
        function hex2rgb(hex) {
          const color = parseInt(hex.slice(1), 16);
          const r = color >> 16 & 255;
          const g = color >> 8 & 255;
          const b = color & 255;
          return {
            r,
            g,
            b
          };
        }
        const targetColor = hex2rgb(payload.color);
        const threshold = payload.threshold || 50;
        const target = document.querySelector(payload.selector);
        if (target) {
          let handleTrigger = function() {
            if (!loaded) {
              video.load();
              loaded = true;
            }
          }, handleCanPlayThrough = function() {
            video.pause();
            resolve();
            video == null ? void 0 : video.removeEventListener("canplaythrough", handleCanPlayThrough);
          }, handleResize = function() {
            unlisten();
            const {
              height
            } = videoWrapper.getBoundingClientRect();
            const clientHeight = document.documentElement.clientHeight;
            if (payload.sticky) {
              videoWrapper.style.top = `${clientHeight - height - 12}px`;
            }
            if (video) {
              canvas.style.width = getComputedStyle(video).width;
              canvas.style.height = getComputedStyle(video).height;
            }
            const scrollTarget = isMobile2 ? target.querySelector(".scroll-target") : target;
            unlisten = scroll((p) => update(p), {
              target: scrollTarget,
              offset: isMobile2 ? ["start start", "end end"] : ["start 70vh", "end end"],
              axis: "y"
            });
          };
          const videoWrapper = target.querySelector(".scroll-follow-video-wrapper");
          const videoTmpl = target.querySelector("template");
          const isMobile2 = isBreakpoint("(max-width: 767px)");
          videoTmpl.innerHTML = videoTmpl.innerHTML.replace('preload="metadata"', 'preload="auto"');
          if (window.Shopify.designMode || !isSameOrigin(payload.source || payload.mp4)) {
            const blob = await getVideoBlob(payload.source || payload.mp4);
            const bloburl = URL.createObjectURL(blob);
            videoTmpl.innerHTML = videoTmpl.innerHTML.replace(/src=".+?"/, `src="${bloburl}"`);
          }
          if (!videoTmpl.innerHTML.includes('preload="')) {
            videoTmpl.innerHTML = videoTmpl.innerHTML.replace("<video ", '<video preload="auto" ');
          }
          const videoFrag = videoTmpl.content.cloneNode(true);
          videoWrapper.appendChild(videoFrag);
          let resolve = () => {
          };
          const metadataAwatied = new Promise((r) => resolve = r);
          const video = videoWrapper.querySelector("video");
          if (!video) return;
          let loaded = false;
          document.addEventListener("wheel", handleTrigger);
          document.addEventListener("scroll", handleTrigger);
          document.addEventListener("touchstart", handleTrigger);
          video.pause();
          video.addEventListener("loadeddata", () => {
            video.play();
            video.pause();
            resolve();
          });
          video.addEventListener("canplaythrough", handleCanPlayThrough);
          await metadataAwatied;
          const canvas = target.querySelector("canvas");
          const duration = video.duration;
          const frameRate = isMobile2 ? 30 : 60;
          const scrollContent = target.querySelector(".scroll-content--inner");
          if (scrollContent) {
            scrollContent.style.display = "block";
          }
          let unlisten = () => {
          };
          let update = () => {
          };
          window.addEventListener("resize", handleResize);
          handleResize();
          let currentTime = 0;
          {
            let createShader = function(gl2, type, source) {
              const shader = gl2.createShader(type);
              if (!shader) {
                console.error("create shader failed");
                return;
              }
              gl2.shaderSource(shader, source);
              gl2.compileShader(shader);
              if (!gl2.getShaderParameter(shader, gl2.COMPILE_STATUS)) {
                console.error("Shader compile failed with: " + gl2.getShaderInfoLog(shader));
                gl2.deleteShader(shader);
                return null;
              }
              return shader;
            }, createProgram = function(gl2, vertexShader2, fragmentShader2) {
              const program2 = gl2.createProgram();
              gl2.attachShader(program2, vertexShader2);
              gl2.attachShader(program2, fragmentShader2);
              gl2.linkProgram(program2);
              if (!gl2.getProgramParameter(program2, gl2.LINK_STATUS)) {
                console.error("Program failed to link: " + gl2.getProgramInfoLog(program2));
                gl2.deleteProgram(program2);
                return null;
              }
              return program2;
            }, render = function() {
              gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
              gl.clear(gl.COLOR_BUFFER_BIT);
              gl.useProgram(program);
              gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
              gl.enableVertexAttribArray(positionLocation);
              gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
              gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
              gl.enableVertexAttribArray(texCoordLocation);
              gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
              gl.bindTexture(gl.TEXTURE_2D, texture);
              gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
              gl.uniform1i(textureLocation, 0);
              gl.uniform3f(chromaKeyColorLocation, targetColor.r / 255, targetColor.g / 255, targetColor.b / 255);
              gl.uniform1f(thresholdLocation, threshold / 255);
              gl.drawArrays(gl.TRIANGLES, 0, 6);
            };
            const vertexShaderSource = `
        attribute vec4 a_position;
        attribute vec2 a_texCoord;
        varying vec2 v_texCoord;
        void main() {
          gl_Position = a_position;
          v_texCoord = vec2(a_texCoord.x, 1.0 - a_texCoord.y);
        }
      `;
            const fragmentShaderSource = `
        precision mediump float;
        varying vec2 v_texCoord;
        uniform sampler2D u_texture;
        uniform vec3 u_chromaKeyColor;
        uniform float u_threshold;
        void main() {
          vec4 color = texture2D(u_texture, v_texCoord);
          float distance = length(color.rgb - u_chromaKeyColor);
          if (distance < u_threshold) {
            discard;
          }
          gl_FragColor = color;
        }
      `;
            const gl = canvas.getContext("webgl");
            if (!gl) {
              console.error("WebGL not supported");
              return;
            }
            const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
            const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
            if (!vertexShader || !fragmentShader) {
              console.error("create shader failed");
              return;
            }
            const program = createProgram(gl, vertexShader, fragmentShader);
            if (!program) return;
            const positionLocation = gl.getAttribLocation(program, "a_position");
            const texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
            const textureLocation = gl.getUniformLocation(program, "u_texture");
            const chromaKeyColorLocation = gl.getUniformLocation(program, "u_chromaKeyColor");
            const thresholdLocation = gl.getUniformLocation(program, "u_threshold");
            const positionBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
            const texCoordBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), gl.STATIC_DRAW);
            const texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            video.addEventListener("play", () => {
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              render();
            });
            update = throttle({
              interval: 1e3 / frameRate
            }, (p) => {
              video.pause();
              currentTime = p * duration || 0;
              video.currentTime = currentTime;
              render();
            });
          }
          unlisten = scroll((p) => update(p), {
            target: isMobile2 ? target.querySelector(".scroll-target") : target,
            offset: isMobile2 ? ["start start", "end -50vh"] : ["start 70vh", "end end"],
            axis: "y"
          });
        }
      }
    }
  };
});
